import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { apiOrigin } from '../services/api-config';

// Set once we've kicked off the Cloudflare Access redirect dance, so a burst of other in-flight
// requests failing the same way doesn't fire the navigation more than once.
let redirectingToAccessLogin = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error) => {
      console.error('HTTP Error:', error);

      // Cloudflare Access blocks an unauthenticated cross-origin request with a CORS error
      // (an opaque, unreadable failure — status 0), not a normal 401 — that's the only signal
      // available to tell "Access hasn't authenticated this browser for the API host yet" apart
      // from a real backend error. This applies to every request, including /auth/login itself:
      // Access gates the whole api host regardless of path, so a wrong-password attempt still
      // comes back as a real, readable 401 (never status 0) and is unaffected by this check —
      // only an Access-level block produces status 0, on any endpoint. A full top-level
      // navigation is required here (not fetch/XHR) since Access only presents its OTP challenge
      // for real navigations; the API's own /auth/cf-return endpoint bounces back here once
      // Access has set the CF_Authorization cookie for the API host.
      const isAccessBlocked = error instanceof HttpErrorResponse && error.status === 0;

      if (isAccessBlocked && !redirectingToAccessLogin) {
        redirectingToAccessLogin = true;
        window.location.href = `${apiOrigin}/api/auth/cf-return`;
      }

      // TODO: Surface backend error JSON shape into a NotificationService.error(...) call
      return throwError(() => error);
    })
  );
};
